import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ComunesService } from '../../../../services/centralization/comunes.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';

@Component({
  selector: 'app-simulacion',
  templateUrl: './simulacion.component.html',
  styleUrls: ['./simulacion.component.css'],
      imports: [
      CommonModule,
      ReactiveFormsModule,
      AutoCompleteModule
    ],
})
export class SimulacionComponent {
  @Input() datosSimulacion: any;
  @Input() error: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private readonly _toastr: ToastrService,
    private readonly _comunesService: ComunesService
  ) {}

  ngOnInit(): void {
    console.log(this.datosSimulacion);
  }

  salir(estado: any) {
    this.activeModal.close(estado);
  }

  descargarErrores(key: any) {
    try {
      console.log(key);
      const fileData: any = { key, metodo: 'get' };
      this._comunesService.getSignedUrl(fileData).subscribe({
        next: (data: any) => {
          console.log(data);
          const url = data.message;
          const link = document.createElement('a');
          link.href = url;
          link.download = key;
          console.log(link.download);
          link.target = '_blank';
          link.click();
        },
        error: (error: any) => {
          console.log(error);
          this._toastr.warning(
            'Ocurrio un problema al intentar descargar el archivo. Intentelo más tarde o contacte con Soporte.',
            'Error'
          );
        }
      });
    } catch (error: any) {
      console.log(error);
    }
  }
}
